// angular import
import { Component, ElementRef, OnInit, output, viewChild, input } from '@angular/core';

// project import
import { FriendsList } from 'src/app/fack-db/friends-list';
import { UserChat } from 'src/app/fack-db/user-chat';
import { ScrollbarComponent } from 'src/app/theme/shared/components/scrollbar/scrollbar.component';
import { SharedModule } from 'src/app/theme/shared/shared.module';

interface ChatMessage {
  type: number;
  msg: string;
  time: string;
}

interface ChatMessageHistory {
  friend_id: number;
  friend_photo: string;
  name?: string;
  messages: ChatMessage[];
}

@Component({
  selector: 'app-chat-msg',
  imports: [SharedModule, ScrollbarComponent],
  templateUrl: './chat-msg.component.html',
  styleUrls: ['./chat-msg.component.scss']
})
export class ChatMsgComponent implements OnInit {
  friendId = input.required<number>();
  ChatToggle = output();
  newChat = viewChild.required('newChat', { read: ElementRef });
  friendsList = FriendsList;
  userChat = UserChat.chat;
  chatMessage?: ChatMessageHistory;
  message!: string;
  message_error!: boolean;
  friendWriting!: boolean;
  newReplay: string;

  // constructor
  constructor() {
    this.newReplay = '';
  }

  ngOnInit() {
    const friend = findObjectByKeyValue(this.friendsList, 'id', this.friendId());
    if (friend) {
      const messageData = findObjectByKeyValue(this.userChat, 'friend_id', this.friendId());
      this.chatMessage = {
        friend_id: friend.id,
        friend_photo: friend.photo,
        name: friend.name,
        messages: messageData ? messageData.messages : []
      };
    }
  }

  sentMsg(flag: number) {
    if (this.message === '' || this.message === undefined) {
      this.message_error = true;
    } else {
      if (flag === 1) {
        this.message_error = false;
      } else {
        this.message_error = false;
        const temp_replay = this.message;
        const html_send =
          '<div class="media chat-messages">' +
          '<div class="media-body chat-menu-reply">' +
          '<div >' +
          '<p class="chat-cont">' +
          this.message +
          '</p>' +
          '</div>' +
          '<p class="chat-time">now</p>' +
          '</div>' +
          '</div>';

        this.newReplay = this.newReplay + html_send;
        this.message = '';
        this.friendWriting = true;
        setTimeout(() => {
          this.friendWriting = false;
          const html_replay =
            '<div class="media chat-messages">' +
            '<a class="media-left photo-table" href="javascript:">' +
            '<img class="media-object img-radius img-radius m-t-5" src="' +
            this.chatMessage?.friend_photo +
            '" alt="' +
            this.chatMessage?.name +
            '">' +
            '</a>' +
            '<div class="media-body chat-menu-content">' +
            '<div >' +
            '<p class="chat-cont">hello superior personality you write</p>' +
            '<p class="chat-cont">' +
            temp_replay +
            '</p>' +
            '</div>' +
            '<p class="chat-time">now</p>' +
            '</div>' +
            '</div>';
          this.newReplay = this.newReplay + html_replay;
        }, 2500);
      }
    }
  }
}

function findObjectByKeyValue<T>(array: T[], key: keyof T, value: T[keyof T]): T | undefined {
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      return array[i];
    }
  }
  return undefined;
}
